if (window.BelleMaisonPartnerTextCleanerLoaded) {
  console.warn('Belle Maison partner text cleaner already loaded.');
} else {
  window.BelleMaisonPartnerTextCleanerLoaded = true;

(function () {
    function normalizeText(value) {
        return (value || '')
          .replace(/\u00a0/g, ' ')
          .replace(/\s+/g, ' ')
          .trim()
          .toLowerCase();
      }

      function markHidden(element) {
        if (!element) return;

        element.setAttribute('data-bm-hide-partner-row', 'true');
        element.classList.add('bm-hide-partner-row');

        element.style.setProperty('display', 'none', 'important');
        element.style.setProperty('visibility', 'hidden', 'important');
        element.style.setProperty('height', '0', 'important');
        element.style.setProperty('min-height', '0', 'important');
        element.style.setProperty('margin', '0', 'important');
        element.style.setProperty('padding', '0', 'important');
        element.style.setProperty('overflow', 'hidden', 'important');
      }

      function rowShouldBeHidden(text) {
        var value = normalizeText(text);

        return (
          value.indexOf('sek/l') !== -1 ||
          value.indexOf('sek / l') !== -1 ||
          value.indexOf('incl. 25% vat') !== -1 ||
          value.indexOf('including 25% vat') !== -1 ||
          value.indexOf('alcohol:') === 0 ||
          value.indexOf('alcohol ') === 0 ||
          value.indexOf('alkohol:') === 0 ||
          value.indexOf('alkohol ') === 0
        );
      }

      function detailsShouldBeHidden(details) {
        var summary = details.querySelector('summary');
        var summaryText = normalizeText(summary ? summary.textContent : '');

        return (
          summaryText === 'allergens' ||
          summaryText.indexOf('allergens') !== -1 ||
          summaryText === 'allergener' ||
          summaryText.indexOf('allergener') !== -1
        );
      }

      function isVisibleEditorialCandidate(element, formatter) {
        if (!element || element === formatter) return false;
        if (element.matches('[data-bm-hide-partner-row="true"], .bm-hide-partner-row')) return false;
        if (element.closest('[data-bm-hide-partner-row="true"], .bm-hide-partner-row')) return false;
        if (element.closest('details')) return false;

        var text = (element.textContent || '').trim();

        if (!text) return false;
        if (rowShouldBeHidden(text)) return false;

        /*
          Safety:
          The intended portal subheading is normally a short editorial line,
          for example "Limited, Light & Complex".
          This avoids accidentally turning a full body paragraph into a heading.
        */
        if (text.length > 90) return false;

        return true;
      }

      function convertFirstEditorialLineToH3(formatter) {
        if (!formatter) return;
        if (formatter.getAttribute('data-bm-subheading-processed') === 'true') return;

        var candidates = formatter.querySelectorAll('h1, h2, h3, h4, p');

        for (var i = 0; i < candidates.length; i++) {
          var element = candidates[i];

          if (!isVisibleEditorialCandidate(element, formatter)) continue;

          if (element.tagName.toLowerCase() === 'h3') {
            element.classList.add('bm-partner-product-subheading');
            element.setAttribute('data-bm-partner-subheading', 'true');
            formatter.setAttribute('data-bm-subheading-processed', 'true');
            return;
          }

          var h3 = document.createElement('h3');
          h3.className = element.className ? element.className + ' bm-partner-product-subheading' : 'bm-partner-product-subheading';
          h3.setAttribute('data-bm-partner-subheading', 'true');
          h3.innerHTML = element.innerHTML;

          element.parentNode.replaceChild(h3, element);
          formatter.setAttribute('data-bm-subheading-processed', 'true');
          return;
        }
      }

      function belleMaisonCleanPartnerProductText() {
        var formatters = document.querySelectorAll('rte-formatter');

        formatters.forEach(function (formatter) {
          /*
            1. Hide known partner price-per-liter paragraph.
          */
          formatter.querySelectorAll('.price-per-liter').forEach(function (element) {
            markHidden(element);
          });

          /*
            2. Hide details/dropdown for allergens.
          */
          formatter.querySelectorAll('details').forEach(function (details) {
            if (detailsShouldBeHidden(details)) {
              markHidden(details);
            }
          });

          /*
            3. Hide exact partner text rows.
          */
          formatter.querySelectorAll('p, div, span, strong, summary').forEach(function (element) {
            var text = element.textContent || '';

            if (!rowShouldBeHidden(text)) return;

            var row =
              element.closest('p') ||
              element.closest('details') ||
              element.closest('div') ||
              element;

            /*
              Safety guard:
              Never hide the entire rte-formatter itself.
            */
            if (row && row !== formatter) {
              markHidden(row);
            }
          });

          /*
            4. Convert first short editorial product-text line to H3.
            This affects the partner description text only, not Belle Maison metafields.
          */
          convertFirstEditorialLineToH3(formatter);
        });
      }

      function runRepeatedlyForLateRendering() {
        belleMaisonCleanPartnerProductText();

        window.setTimeout(belleMaisonCleanPartnerProductText, 100);
        window.setTimeout(belleMaisonCleanPartnerProductText, 300);
        window.setTimeout(belleMaisonCleanPartnerProductText, 700);
        window.setTimeout(belleMaisonCleanPartnerProductText, 1500);
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', runRepeatedlyForLateRendering);
      } else {
        runRepeatedlyForLateRendering();
      }

      document.addEventListener('shopify:section:load', runRepeatedlyForLateRendering);

      var observer = new MutationObserver(function () {
        belleMaisonCleanPartnerProductText();
      });

      var observer = new MutationObserver(function () {
  belleMaisonCleanPartnerProductText();
});

var productDetailsRoot =
  document.querySelector('.product-details.sticky-content--desktop') ||
  document.querySelector('.product-details') ||
  document.querySelector('main#MainContent');

observer.observe(productDetailsRoot, {
  childList: true,
  subtree: true
      });
    })();
    }